import { render, staticRenderFns } from "./UserSpecifications.vue?vue&type=template&id=54adf537"
import script from "./UserSpecifications.vue?vue&type=script&lang=js"
export * from "./UserSpecifications.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports